// permissions.js
export const PERMISSIONS = {
  GENERAL: {
    VIEW_SEARCH: "general_view_search",
    VIEW_TALOYHTIOKORTIT: "general_view_taloyhtiokortit",
    VIEW_PROFILE: "general_view_profile",
    MANAGE_USERS: "general_manage_users",
    VIEW_KOHO: "general_view_koho",
  },

  TALOYHTIOKORTTI: {
    VIEW: "taloyhtiokortti_view",
    USE_HAE_TULOSTEITA: "taloyhtiokortti_use_hae_tulosteita",
    USE_HAE_TIETOJA: "taloyhtiokortti_use_hae_tietoja",
    MOVE_REPORT: 'move_report'
  },

  KEHITYSLISTA: {
    VIEW: 'kehityslista_view',
  },

  REPORTS: {
    VIEW_ALL: "reports_view_all",
    VIEW_OWN: "reports_view_own",
    EDIT: "reports_edit",
    DELETE: "reports_delete",
    EXPORT: "reports_export",
    VIEW_TEMPLATES: "reports_view_templates",
    ASSIGN_REPORT_MAKER: "assign_report_maker",
    AI_GENERATE: "reports_ai_generate",
    MANAGE_TEXT_RECOMMENDATIONS: "reports_manage_text_recommendations",
  },
};